import React from "react";

const ShowHideButtonBlock = ({ id, block, title_block, handleBlock }) => {
  return (
  <p
  className="text-blue-600 text-xs  cursor-pointer"
  onClick={() => handleBlock(id, block, title_block)}
>
  Change
</p>

  );
};

export default ShowHideButtonBlock;
